import React, { Component } from "react";
import { connect } from "react-redux";

// React Bootstrap
import Container from "react-bootstrap/Container";
import Button from "react-bootstrap/Button";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";

import Logo from "../../images/logo.png";

const UserProfile = props => {
  const { auth, profile } = props;
  return (
    <div>
      <h3>This is user profile page</h3>
    </div>
  );
};

const mapStateToProps = state => {
  console.log(state);
  return {
    auth: state.firebase.auth,
    profile: state.firebase.profile
  };
};

export default connect(mapStateToProps)(UserProfile);
